module.exports = __webpack_public_path__ + "static/media/login_bg.8dd6f0ae.jpg";